import { render, staticRenderFns } from "./agent_sessions_list.vue?vue&type=template&id=447202e0"
import script from "./agent_sessions_list.vue?vue&type=script&lang=js"
export * from "./agent_sessions_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports